module.exports = __webpack_public_path__ + "static/img/banner_04.1db706f6.png";